/**
 * Loading overlay management
 * 
 * This script handles the loading overlay that is displayed while the application resources
 * are loading. The overlay is shown immediately (with inline styles) and hidden
 * when both DOM and Livewire are ready.
 */
let livewireReady = false;
let domReady = false;
const FALLBACK_TIMEOUT = 5000; // Maximum wait time in ms

// Event fired when DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
    domReady = true;
    checkIfFullyLoaded();
});

// Event fired when Livewire is initialized
document.addEventListener('livewire:init', function() {
    livewireReady = true;
    checkIfFullyLoaded();
    
    // Listen for Livewire navigation events
    Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
        // When navigation is successful
        succeed(({ snapshot, effect }) => {
            if (effect && effect.type === 'navigate') {
                hideLoadingOverlay();
            }
        });
    });
});

// Also hide overlay when page is fully loaded (for non-Livewire pages)
window.addEventListener('load', function() {
    hideLoadingOverlay();
});

// Check if both DOM and Livewire are ready
function checkIfFullyLoaded() {
    if (domReady && livewireReady) {
        hideLoadingOverlay();
    }
}

// Hide the loading overlay with a smooth transition
function hideLoadingOverlay() {
    setTimeout(function() {
        const overlay = document.getElementById('loading-overlay');
        if (!overlay) return;
        
        overlay.style.opacity = '0';

        setTimeout(function() {
            overlay.style.display = 'none';
        }, 300); // Transition time
    }, 300); // Small delay to ensure everything is ready
}

// Fallback: ensure the overlay is hidden even if some event fails
setTimeout(function() {
    const overlay = document.getElementById('loading-overlay');
    if (!overlay) return;
    
    // If after the maximum time the overlay is still visible, hide it
    if (overlay.style.display !== 'none') {
        console.warn('Loading overlay hidden by safety timeout');
        hideLoadingOverlay();
    }
}, FALLBACK_TIMEOUT);

// Function to show the loading overlay (useful for manual control)
function showLoadingOverlay() {
    const overlay = document.getElementById('loading-overlay');
    if (!overlay) return;
    
    overlay.style.display = 'flex';
    overlay.style.opacity = '1';
}

export { hideLoadingOverlay, showLoadingOverlay };